import { DonationAmountWithConfig } from "@/components/DonationAmount";
import { DonationIntentWithConfig } from "@/components/DonationIntent";
import { useDonationFormStore } from "@/stores";
import { Button } from "@/components/ui/Button";
import classes from "./Form.module.scss";
import { useTranslation } from "@/hooks/useTranslation";
import { ImperativeHandle } from "@/types/Form";
import { useRef } from "react";
import { dispatchEvent } from "@/utils/event-dispacher";
import { EventName } from "@/types/Events";
import { CURRENCY } from "@/config";

type FormStepAmountProps = {
  onStepSubmit: () => void;
};

export function FormStepAmount(props: FormStepAmountProps) {
  const { onStepSubmit } = props;

  const amountFormRef = useRef<ImperativeHandle>(null);

  const { donationType, donationAmount, donationOneOffType } =
    useDonationFormStore();

  const showDonationIntent =
    donationType === "one-off" && donationAmount !== null;

  const showSubmitButton =
    donationAmount !== null &&
    (!showDonationIntent || donationOneOffType !== null);

  const t = useTranslation("_common");

  const handleSubmit = async () => {
    const validation = await amountFormRef.current?.validate();
    if (validation?.isValid) {
      dispatchEvent(EventName.SELECT_AMOUNT, {
        amount: donationAmount!,
        currency: CURRENCY,
        donation_type: donationType!,
      });
      onStepSubmit();
    }
  };

  return (
    <>
      <DonationAmountWithConfig ref={amountFormRef} />

      {showDonationIntent && (
        <div className={classes.marginBottom}>
          <DonationIntentWithConfig />
        </div>
      )}

      {showSubmitButton && (
        <div className={classes.pagination}>
          <Button size="large" variant="outlined" onClick={handleSubmit}>
            {t("continue")}
          </Button>
        </div>
      )}
    </>
  );
}
